import React, { useState, useEffect, useRef } from "react";
import "./SocialBar.css";
import {
  FaWhatsapp,
  FaInstagram,
  FaYoutube,
  FaGoogle,
  FaTimes,
  FaCopy,
} from "react-icons/fa";

export default function SocialBar() {
  const [waOpen, setWaOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const panelRef = useRef(null);

  const doctors = [
    {
      id: 1,
      name: "Dr. Saurabh S. Chavan",
      role: "General & Laparoscopic Surgeon",
      phone: "+918983501558",
      displayPhone: "+91 89835 01558",
    },
    {
      id: 2,
      name: "Dr. Shubhada Bahirat-Chavan",
      role: "Gynecologist",
      phone: "+917823831068",
      displayPhone: "+91 78238 31068",
    },
  ];

  useEffect(() => {
    function handleOutside(e) {
      if (waOpen && panelRef.current && !panelRef.current.contains(e.target)) {
        setWaOpen(false);
      }
    }
    function onEsc(e) {
      if (e.key === "Escape") setWaOpen(false);
    }
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("keydown", onEsc);
    };
  }, [waOpen]);

  const handleCopy = async (phone) => {
    try {
      await navigator.clipboard.writeText(phone);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {}
  };

  const openWhatsApp = (phone) => {
    const normalized = phone.replace(/\+/g, "").replace(/[^0-9]/g, "");
    const url = `https://wa.me/${normalized}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      {/* WhatsApp side panel */}
      <aside
        className={`wa-panel ${waOpen ? "open" : ""}`}
        aria-hidden={!waOpen}
        ref={panelRef}
      >
        <div className="wa-panel-header">
          <div className="wa-header-title">
            <FaWhatsapp className="wa-header-icon" aria-hidden="true" />
            <div>
              <div className="wa-title">WhatsApp</div>
              <div className="wa-sub">Choose a doctor to message</div>
            </div>
          </div>
          <button
            className="wa-close-btn"
            onClick={() => setWaOpen(false)}
            aria-label="Close WhatsApp panel"
          >
            <FaTimes />
          </button>
        </div>

        <div className="wa-panel-body">
          {doctors.map((d) => (
            <div className="wa-doctor" key={d.id}>
              <div className="wa-doc-left">
                <div className="wa-avatar">{getAvatarInitials(d.name)}</div>
              </div>

              <div className="wa-doc-mid">
                <div className="wa-doc-name">{d.name}</div>
                <div className="wa-doc-role">{d.role}</div>
                <div className="wa-doc-phone">{d.displayPhone}</div>
              </div>

              <div className="wa-doc-actions">
                <button
                  className="wa-action wa-msg"
                  onClick={() => openWhatsApp(d.phone)}
                  aria-label={`WhatsApp ${d.name}`}
                >
                  Message
                </button>
                <button
                  className="wa-action wa-copy"
                  onClick={() => handleCopy(d.phone)}
                  aria-label={`Copy ${d.name} phone`}
                  title="Copy number"
                >
                  <FaCopy />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="wa-panel-footer">
          <small className="wa-note">
            By clicking Message you will be redirected to WhatsApp.
          </small>
        </div>
      </aside>

      {/* Copy toast */}
      <div className={`wa-toast ${copied ? "visible" : ""}`} role="status">
        Number copied to clipboard
      </div>

      {/* Social icons vertical bar */}
      <div className="social-box" aria-label="Social links">
        <button
          className="wa-toggle"
          onClick={() => setWaOpen((v) => !v)}
          aria-expanded={waOpen}
          aria-controls="wa-panel"
          data-title="WhatsApp"
        >
          <FaWhatsapp className="icn" />
        </button>

        <a
          href="https://www.instagram.com/chavanmultispecialityhospital"
          target="_blank"
          rel="noopener noreferrer"
          data-title="Instagram"
        >
          <FaInstagram className="icn" />
        </a>

        <a
          href="https://share.google/T06OZ101oRQl9NeX7"
          target="_blank"
          rel="noopener noreferrer"
          data-title="YouTube"
        >
          <FaYoutube className="icn" />
        </a>

        <a
          href="https://share.google/T06OZ101oRQl9NeX7"
          target="_blank"
          rel="noopener noreferrer"
          data-title="Google Business"
        >
          <FaGoogle className="icn" />
        </a>
      </div>
    </>
  );
}

function getAvatarInitials(name = "") {
  const parts = name.split(" ").filter(Boolean);
  if (parts.length === 0) return "D";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
